import Styled from 'styled-components';

const InfoWraper = Styled.div`
    display: flex;
    justify-content: space-between;
    width: 50%;
    max-width: 60px;
    min-width: 53px;
    align-items: center;
    padding: 12px 0;    
    color: #202349;  
    @media only screen and (max-width: 1024px) {
        padding: 12px 0; 
}
    @media only screen and (max-width: 500px) {
        padding: 12px 0; 
}
    @media only screen and (max-width: 425px) {
        width: 100%;
        padding: 0px;    
}
    @media only screen and (max-width: 375px) {
    justify-content: center;
    gap: 0;
    padding-right: 1px;
}
@media only screen and (max-width: 335px) {
    padding-right: 0px;
}
    .shopping-cart-icon {
        @media only screen and (max-width: 500px) {
    width: 14px !important;
    height: 14px !important;
} 

}
.settings-icon {
    @media only screen and (max-width: 500px) {
    width: 14px !important;
    height: 14px !important;
} 
@media only screen and (max-width: 320px) {
    margin-left: -10px;
}
}
.avatar-border {
    border: 2px solid ${({ theme }) => theme.avatarBorder};
    display: flex;
    border-radius: 50%;
    padding: 3px;
    justify-content: center;
align-items: center;
@media only screen and (max-width: 375px) {
    margin-left: -5px;
}
@media only screen and (max-width: 320px) {
    margin-left: -10px;
}
}
        #not-allowed{
        &:hover {
            cursor: not-allowed !important;
        }
    }
    .head-example{
        text-decoration: none;
        color: ${({ theme }) => theme['text-color-secondary']};
        box-shadow: none;
        margin: 0px !important;
        padding: 0px !important;
        display: flex !important;
        ${({ darkMode }) => (darkMode ? `color: #A8AAB3;` : '')};
        @media only screen and (max-width: 320px) {
        margin: 0px !important;
        padding: 0px !important;
}
    }
    .head-example.blocked{
        cursor: not-allowed;
    }
    .message .ant-badge-dot{
        background: green
    }
    .ant-badge{
        .ant-badge-dot{
            ${({ theme }) => (theme.rtl ? 'left' : 'right')}: 50% !important;
        }
    }
    .flag-select{
        padding-bottom: 0;
        .flag-select__option{
            margin: 0;
            img{
                top: 0;
            }
        }
        .flag-select__btn{
            line-height: 0;
            padding-right: 0;
            cursor: pointer;
        }
        .flag-select__btn:after{
            content: none;
        }
        .flag-select__options{
            width: 120px;
            padding-top: 0;
            margin: 0;
            right: 0;
            top: 30px;
            display: block;
            .flag-select__option{
                line-height: normal;
                display: block;
                padding: 5px 10px;
                span{
                    width: auto !important;
                    height: auto !important;
                    display: block;
                }
            }
        }
    }
    .message, .notification, .settings, .support, .flag-select, .nav-author{
        display: flex;
        span, a{
            display: block;
            line-height: normal;
            margin: 0 3px;
        }
    }
    .settings {
        width: 31px;
        justify-content: center;
        @media only screen and (max-width: 325px) {
            margin-right: -7px;
}
    }
    .message {
        width: 31px;
        @media only screen and (max-width: 455px) {
            justify-content: center;
}
    }
    .topBar-avatar-class{
        margin-right: 0px !important;

        /* @media only screen and (max-width: 325px) {
            margin-right: 0px !important;
} */
    }
    .nav-author{
        width: 36px;
        justify-content: flex-end;
        a.ant-dropdown-trigger{
            img{
                max-width: 20px;
            }
        }
        @media only screen and (max-width: 468px) {
            width: 31px;
}
@media only screen and (max-width: 325px) {
    width: 31px;
}
    }

    .flag-select {
        ul{
            width: 170px !important;
            padding: 12px 0;
            background: #fff;
            border: 0 none;
            box-shadow: 0 5px 30px ${({ theme }) => theme['gray-solid']}15;
            li{
                &:first-child{
                    margin-top: 12px;
                }
                &:hover{
                    background: ${({ theme }) => theme['primary-color']}05;
                }
                span{
                    display: flex !important;
                    align-items: center;
                    padding: 2px 10px;
                    img{
                        border-radius: 50%;
                    }
                    span{
                        font-weight: 500;
                        color: ${({ theme }) => theme['gray-color']};
                        padding: 0;
                        margin-left: 10px;
                    }
                }
            }
        }
    }

`;

const SettingDropdwon = Styled.div`
    .setting-dropdwon{
        max-width: 700px;
        padding: 4px 0;
        .setting-dropdwon__single{
            align-items: flex-start;
            padding: 16px 20px;
            margin-bottom: 0;
            position: relative;
            &:after{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                box-shadow: 0 5px 20px ${({ theme }) => theme['gray-solid']}15;
                z-index: 1;
                content: '';
                opacity: 0;
                visibility: hidden;
            }
            &:hover{
                &:after{
                    opacity: 1;
                    visibility: visible;
                }
            }
            h1{
                font-size: 15px;
                font-weight: 500;
                margin: -4px 0 2px;
            }
            p{
                margin-bottom: 0;
                color: ${({ theme }) => theme['gray-solid']};
            }
            img{
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 16px;
                transform: ${({ theme }) => (theme.rtl ? 'rotatey(180deg)' : 'rotatey(0deg)')};
            }
            figcaption{
                text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')}
            }
        }
    }
`;

const NestedDropdwon = Styled.div`
    .support-dropdwon{
        padding: 10px 15px;
        text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')};
        ul{
            &:not(:last-child){
                margin-bottom: 16px;
            }
            h1{
                font-size: 14px;
                font-weight: 400;
                color: ${({ theme }) => theme['light-color']};
            }
            li{
                a{
                    font-weight: 500;
                    padding: 4px 16px;
                    color: ${({ theme }) => theme['dark-color']};
                    &:hover{
                        background: #fff;
                        color: ${({ theme }) => theme['primary-color']};
                    }
                }
            }
        }
    }
`;

const UserDropDwon = Styled.div`
    .user-dropdwon{
        max-width: 280px;
        .user-dropdwon__info{
            display: flex;
            align-items: center;
            border-radius: 8px;
            margin-bottom: 12px;
            margin-left: 12px;
            margin-right: 12px;
            padding-left: 11px;
            height: 60px;
            background: #D7DBDE !important;
            img{
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
            }
            figcaption{
                h1{
                    font-size: 14px;
                    margin-bottom: 2px;
                    color:  ${({ theme }) => theme['dark-color']};
                }
                p{
                    margin-bottom: 0px;
                    font-size: 13px;
                    color: ${({ theme }) => theme['gray-solid']};
                }
            }
            .user-name-and-surname {
                font-size: 12px;
                font-weight: bold;
                color: #5D5F79;
                margin-top: 1px;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: -3px;
                max-width: 135px;
                white-space: nowrap;
            }
            .user-role {
                font-size: 12px;
                font-weight: 400;
                color: #878EAA;
            }
        }
        .avatar-border-dropdown {
            border: 2px solid ${({ theme }) => theme.avatarBorder};
            display: flex;
            border-radius: 50%;
            padding: 3px;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 36px;
           // margin-right: 10px;
}
        .user-dropdwon__links{
            a{
                width: 100%;
                left: -15px;
                right: -15px;
                display: inline-flex;
                align-items: center;
                padding: 10px 12px;
                padding-left: 24px;
                font-size: 12px;
                font-weight: 500;
                color: #878EAA;
                transition: .3s;
                &:hover{
                    background: ${({ theme }) => theme.myProfileNavlinkHover} !important;
                    //color: ${({ theme }) => theme['primary-color']};
                   // ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 22px !important;
                }
                svg{
                    width: 16px;
                    transform: ${({ theme }) => (theme.rtl ? 'rotateY(180deg)' : 'rotateY(0deg)')};
                    ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 14px;
                }
            }
        }
        .user-dropdwon__links.blocked{
            a{
            cursor: not-allowed !important;
            }
        }
        .user-dropdwon__bottomAction{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: bold;
            text-align: center;
            position: relative;
            width: 100%;
            height: 35px;
            bottom: -15px;
            border-radius: 0 0 5px 5px;
            padding: 15px 0;
            background: #EAECED;
            color: #878EAA;
            svg{
                width: 15px;
                height: 15px;
                ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
            }
        }
        .user-dropdown-avatar-wrapper {
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 10px;
              margin-top: 3px;
        }
    }
`;

const AtbdTopDropdwon = Styled.div`
    .atbd-top-dropdwon__title .title-text {        
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 10px;
    }
    .atbd-top-dropdwon__content figcaption .atbd-top-dropdwonText {
        min-width: 216px;
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 15px;
    }
    .atbd-top-dropdwon__content .notification-icon {
        width: 39.2px;
        height: 32px;
        ${({ theme }) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .atbd-top-dropdwon__content .notification-icon.bg-primary {
        background: #2280F415;
        color: #2280F4;
    }
    .atbd-top-dropdwon__content .notification-icon.bg-secondary {
        background: #FF69A515;
        color: #FF69A5;
    }
    .atbd-top-dropdwon__content .notification-icon svg {
        width: 18px;
        height: 18px;
    }
    .atbd-top-dropdwon__content .notification-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }  

    .atbd-top-dropdwon__content figcaption span {
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0;
    }

    .notification-text h1 {
        font-size: 14px;
        font-weight: 400;
        color: #5A5F7D;
        margin-bottom: 4px;
    }

    .notification-text h1 span {
        color:  ${({ theme }) => theme.primaryButtonsColor};
        font-weight: 500;
        ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 0;
    }

    .notification-text p {
        font-size: 12px;
        color: #ADB4D2;
        margin-bottom: 0;
        text-align: ${({ theme }) => (!theme.rtl ? 'left' : 'right')}
    }
`;

const NavAuth = Styled.span`
    i, svg, img {
        ${({ theme }) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
    }
`;

export { InfoWraper, SettingDropdwon, NestedDropdwon, UserDropDwon, AtbdTopDropdwon, NavAuth };
